module.exports = __webpack_public_path__ + "fonts/icomoon.286f62a5.woff";